import { LeftArrow } from "assets/icons";
import { useNavigate } from "react-router-dom";
import { Icon } from "ui";

import { GoBackHeaderTitleProps } from "./GoBackHeaderTitle.types";

import styles from "./GoBackHeaderTitle.module.scss";

const GoBackHeaderTitle = ({ title, onGoBack }: GoBackHeaderTitleProps) => {
  const navigate = useNavigate();

  const handleGoBackClick = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <button className={styles.title} onClick={handleGoBackClick}>
      <Icon type="button" as={LeftArrow} boxSize={32} />
      {title}
    </button>
  );
};

export default GoBackHeaderTitle;
